import React from 'react';
import DynamicNEETTest from './DynamicNEETTest';
import { freeNEETTestsMetadata } from '../../../data/freeNEETTestData';

export default function FreeNEETTest() {
  return <DynamicNEETTest testsMetadata={freeNEETTestsMetadata} />;
}
